import noop from "lodash/noop";

import {
  AnalyticsComponent,
  AnalyticsFieldName,
  OnboardingV2AnalyticsEvent,
  OnboardingV2AnalyticsPageView,
} from "@/constants/analytics/Analytics";
import type { OnboardingStepName } from "@/constants/Onboarding";
import { OnboardingStepName as StepName } from "@/constants/Onboarding";
import { useAnalytics } from "@/services/Analytics";

interface StepActionConfig {
  analyticsEvent: OnboardingV2AnalyticsEvent;
  handler: () => void;
}

// TODO: wire each step handler to its navigation target when step screens are ready
const StepActionConfigRecord: Record<OnboardingStepName, StepActionConfig> = {
  [StepName.CareTeam]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.CareTeamActionPressed,
    handler: noop,
  },
  [StepName.ClinicalPicture]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.ClinicalPictureActionPressed,
    handler: noop,
  },
  [StepName.Initial]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.ProfileActionPressed,
    handler: noop,
  },
  [StepName.Profile]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.ProfileActionPressed,
    handler: noop,
  },
  [StepName.Treatment]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.TreatmentActionPressed,
    handler: noop,
  },
  [StepName.YourWhy]: {
    analyticsEvent: OnboardingV2AnalyticsEvent.YourWhyActionPressed,
    handler: noop,
  },
};

interface UseOnboardingStepHandler {
  onStepActionPress: (stepName: OnboardingStepName) => void;
}

const useOnboardingStepHandler = (): UseOnboardingStepHandler => {
  const { track } = useAnalytics();

  const onStepActionPress = (stepName: OnboardingStepName) => {
    const config = StepActionConfigRecord[stepName];

    track(config.analyticsEvent, {
      [AnalyticsFieldName.Component]: AnalyticsComponent.Button,
      [AnalyticsFieldName.Source]: OnboardingV2AnalyticsPageView.Modal,
    });

    config.handler();
  };

  return { onStepActionPress };
};

export default useOnboardingStepHandler;
